import { DictionaryType } from 'helper/types';
import { createSelector } from '@reduxjs/toolkit';
import { stationsFullSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { CreateSelector } from 'Features/App/store';
import {selectedTypeIdSelector, stationSearchTextSelector} from 'Features/Filters/filtersSlice';
import { StationFullType } from 'Services/api/v2';
import { selectedRegionIdsSelector } from '../filtersSlice';
import { FilterStationsFull, getStationFullIds } from './filters';
import { filteredDatasourcesIdsSelector } from '../Datasources';

/**
 * фильтрация станций по выбранному/вписанному:
 * * имени/idx
 * * региону
 * * источнику
 */
const filteredStationsFullSelector: CreateSelector<DictionaryType<StationFullType>> = createSelector(
  [
    stationsFullSelector,
    stationSearchTextSelector,
    selectedRegionIdsSelector,
    filteredDatasourcesIdsSelector,
    selectedTypeIdSelector
  ],
  (stationsFull, searchText, regionIds, datasourceIds, typeId) => {
    const filtered = FilterStationsFull
      .setValues(Object.values(stationsFull))
      .bySearchText(searchText)
      .byRegionIds(regionIds)
      .byDatasourceIds(datasourceIds)
      .byTypeId(typeId);
    return filtered.getDictionary();
  },
);

export const filteredStationsIdsSelector: CreateSelector<number[]> = createSelector(
  filteredStationsFullSelector,
  (stationsFull) => {
    return getStationFullIds(stationsFull);
  },
);

export const filteredStationsIdsLengthSelector = createSelector(
  filteredStationsIdsSelector,
  (ids) => ids.length,
);

export const stationDatasourceIdsFromFilteredSelector = (stationId: number):CreateSelector<number[]> => createSelector(
  filteredStationsFullSelector,
  (stationsFull) => {
    const { datasourceIds } = stationsFull[stationId];
    return datasourceIds;
  },
);
